import { ReactComponent as GroupStatement } from '../../resources/images/header-icons/groupStatement.svg';
import { ReactComponent as Advantages } from '../../resources/images/header-icons/advantages.svg';
import { ReactComponent as BeforeTravel } from '../../resources/images/header-icons/beforeTravel.svg';
import { ReactComponent as DuringTravel } from '../../resources/images/header-icons/duringTravel.svg';

export default {
  ge: {
    items: [
      {
        key: 'group-statements',
        label: 'group_statements',
        Icon: GroupStatement,
      },
      {
        key: 'advantages',
        label: 'advantages',
        Icon: Advantages,
      },
      {
        key: 'before-departure',
        label: 'before_departure',
        Icon: BeforeTravel,
      },
      {
        key: 'during-travel',
        label: 'during_travel',
        Icon: DuringTravel,
      },
      {
        key: 'instructions',
        label: 'instructions',
        muted: true,
      },
      {
        key: 'terms',
        label: 'terms_and_conditions',
        tabLabel: 'terms_conditions',
        contentKey: 'terms-conditions',
        muted: true,
        isDefault: true,
      },
      {
        key: 'confidentiality',
        label: 'confidentiality_policy',
        contentKey: 'confidentiality-policy',
        muted: true,
      },
      {
        key: 'compensation-terms',
        label: 'compensation_terms',
        muted: true,
      },
      {
        key: 'faq',
        label: 'faq',
        muted: true,
      },
      {
        key: 'contact',
        labels: ['help', 'contact'],
        muted: true,
      },
    ],
    adminItems: [
      { key: 'terms-conditions', label: 'terms_conditions' },
      { key: 'confidentiality-policy', label: 'confidentiality_policy' },
      { key: 'instructions', label: 'instructions' },
      { key: 'invoice-terms', label: 'invoice_terms' },
      { key: 'compensation-terms', label: 'compensation_terms' },
      { key: 'before-departure', label: 'before_departure' },
      { key: 'group-statements', label: 'group_statements' },
      { key: 'during-travel', label: 'during_travel' },
      { key: 'advantages', label: 'advantages' },
      { key: 'faq', label: 'faq' },
      { key: 'contact', label: 'contact' },
      { key: 'notifications', label: 'notifications', noTrans: true },
    ],
  },
  am: {
    items: [
      {
        key: 'general-information',
        label: 'general_information',
      },
      {
        key: 'transportation-rules',
        label: 'transportation_rules',
      },
      {
        key: 'fares-and-tickets',
        label: 'fares_and_tickets',
      },
      {
        key: 'ticket-changes',
        label: 'ticket_changes',
      },
      {
        key: 'instructions',
        label: 'instructions',
      },
      {
        key: 'terms',
        label: 'terms_and_conditions',
        tabLabel: 'terms_conditions',
        contentKey: 'terms-conditions',
        isDefault: true,
      },
      {
        key: 'confidentiality',
        label: 'confidentiality_policy',
        contentKey: 'confidentiality-policy',
      },
      {
        key: 'faq',
        label: 'faq',
      },
      {
        key: 'contact',
        label: 'contact',
      },
    ],
    adminItems: [
      { key: 'general-information', label: 'general_information' },
      { key: 'transportation-rules', label: 'transportation_rules' },
      { key: 'fares-and-tickets', label: 'fares_and_tickets' },
      { key: 'ticket-changes', label: 'ticket_changes' },
      { key: 'instructions', label: 'instructions' },
      { key: 'terms-conditions', label: 'terms_conditions' },
      { key: 'confidentiality-policy', label: 'confidentiality_policy' },
      { key: 'faq', label: 'faq' },
      { key: 'contact', label: 'contact' },
      { key: 'notifications', label: 'notifications', noTrans: true },
    ],
  },
};
